import { render, staticRenderFns } from "./PromotionDappLimitAll.vue?vue&type=template&id=67ae1289&scoped=true&"
import script from "./PromotionDappLimitAll.vue?vue&type=script&lang=js&"
export * from "./PromotionDappLimitAll.vue?vue&type=script&lang=js&"
import style0 from "./PromotionDappLimitAll.vue?vue&type=style&index=0&id=67ae1289&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ae1289",
  null
  
)

export default component.exports